import axios from 'axios';
import { baseUrlAPI } from '@/globals';
import ErrorNotifier from '@/domain/util/notifications/ErrorNotifier';
import SuccessNotifier from '@/domain/util/notifications/SuccessNotifier';
import { editUpdatedItem, removeDeletedItem } from '@/domain/services/common/UpdateItemService';
export const state = {
    complaint: {
        id: 0,
        region: '',
        district: '',
        city: '',
        street: '',
        house: '',
        structure: '',
        building: '',
        description: '',
        result: '',
        registration_number: '',
        registration_date: '',
        attachments: [],
        status: 'draft',
        installation_date: new Date(Date.now()).toJSON().slice(0, 10),
        bad_date: new Date(Date.now()).toJSON().slice(0, 10),
        conditions: '',
        wishes: '',
        complaint_id: '',
    },
    complaints: [],
};
export const actions = {
    /**
     * Получить все рекламации
     */
    async getClientComplaints() {
        try {
            const res = await axios.get(`${baseUrlAPI}client/complaint/user`);
            state.complaints = res.data;
        }
        catch {
            ErrorNotifier.notify();
        }
    },
    /**
     * Получить архив заявок
     */
    async getArchiveClientComplaints() {
        try {
            const res = await axios.get(`${baseUrlAPI}client/complaint/user/archive`);
            state.complaints = res.data;
        }
        catch {
            ErrorNotifier.notify();
        }
    },
    /**
     * Создать или обновить рекламацию
     */
    async updateClientComplaint() {
        try {
            if (state.complaint.id !== 0) {
                const res = await axios.put(`${baseUrlAPI}client/complaint/${state.complaint.id}`, state.complaint);
                if (state.complaint.status === 'draft') {
                    SuccessNotifier.notify('Данные сохранены', 'Черновик заявки скорректирован');
                }
                else {
                    SuccessNotifier.notify('Заявка отправлена на рассмотрение', `Заявка отправлена на рассмотрение. Подтверждение получения будет направлено на адрес электронной почты`);
                }
                state.complaints = editUpdatedItem(state.complaints, res.data);
            }
            else {
                const res = await axios.post(`${baseUrlAPI}client/complaint`, state.complaint);
                if (state.complaint.status === 'draft') {
                    SuccessNotifier.notify('Заявка создана', 'Создан черновик новой заявки');
                }
                else {
                    SuccessNotifier.notify('Заявка отправлена на рассмотрение', `Заявка отправлена на рассмотрение. Подтверждение получения будет направлено на адрес электронной почты`);
                }
                state.complaint = Object.assign({}, res.data, state.complaint);
                state.complaints.push(res.data);
            }
        }
        catch {
            ErrorNotifier.notify();
        }
    },
    /**
     * Отправить рекламацию в архив
     * @returns {Promise<void>}
     */
    async archiveClientComplaint() {
        try {
            if (state.complaint.id !== 0) {
                state.complaint.status = 'archive';
                const res = await axios.put(`${baseUrlAPI}client/complaint/${state.complaint.id}`, state.complaint);
                SuccessNotifier.notify('Данные сохранены', `Заявка перемещена в архив`);
                state.complaints = removeDeletedItem(state.complaints, state.complaint);
            }
        }
        catch {
            ErrorNotifier.notify();
        }
    },
    /**
     * Удалить рекламацию
     * @returns {Promise<void>}
     */
    async deleteClientComplaint() {
        try {
            if (state.complaint.id !== 0) {
                const res = await axios.delete(`${baseUrlAPI}client/complaint/${state.complaint.id}`);
                SuccessNotifier.notify('Данные удалены', `Заявка удалена`);
                state.complaints = removeDeletedItem(state.complaints, state.complaint);
            }
        }
        catch {
            ErrorNotifier.notify();
        }
    },
    /**
     * Выделить
     * @param payload
     */
    setSingleClientComplaint({}, payload) {
        state.complaint = Object.assign({}, state.complaint, payload);
        if (state.complaint.region === null) {
            state.complaint.region = '';
        }
        if (state.complaint.district === null) {
            state.complaint.district = '';
        }
        if (state.complaint.city === null) {
            state.complaint.city = '';
        }
        if (state.complaint.house === null) {
            state.complaint.house = '';
        }
        if (state.complaint.structure === null) {
            state.complaint.structure = '';
        }
    },
    /**
     * Отменить выделение
     */
    unsetSingleClientComplaint() {
        state.complaint = {
            id: 0,
            region: '',
            district: '',
            city: '',
            street: '',
            house: '',
            structure: '',
            building: '',
            description: '',
            result: '',
            registration_number: '',
            registration_date: '',
            attachments: [],
            status: 'draft',
            installation_date: new Date(Date.now()).toJSON().slice(0, 10),
            bad_date: new Date(Date.now()).toJSON().slice(0, 10),
            conditions: '',
            wishes: '',
            complaint_id: '',
        };
    },
};
export const clientComplaint = {
    state, actions,
};
//# sourceMappingURL=clientComplaint.js.map